<template>
  <hm-content title="">
    <div class="mb20">
      <el-radio-group
          v-model="searchCondition.expressSendMode"
          size="small"
          @change="switchTab"
      >
        <el-radio-button label="self">自发货列表</el-radio-button>
        <el-radio-button label="third" v-if="isBtn('sanfang:false')"
        >三方发货列表</el-radio-button
        >
      </el-radio-group>
    </div>
    <div
        class="table-panel flex"
        style="margin-bottom: 20px"
        :class="
        searchCondition.expressSendMode === 'self'
          ? 'flex-between'
          : 'flex-start'
      "
    >
      <el-radio-group
          v-model="searchCondition.timeStatus"
          size="small"
          @change="shippingSwitchTab"
      >
        <el-radio-button
            label="daipeihuo"
            v-if="searchCondition.expressSendMode === 'self'"
        >待配货({{ noDelivery }})</el-radio-button
        >
        <el-radio-button label="daifahuo"
        >待发货({{ noExpress }})</el-radio-button
        >
        <el-radio-button label="yifahuo"
        >已发货({{ isExpress }})</el-radio-button
        >
        <el-radio-button label="guaqi">已挂起({{ guaqiNum }})</el-radio-button>
      </el-radio-group>
    </div>
    <div
        class="flex-1 text-left mb20"
        v-if="searchCondition.expressSendMode === 'self'"
    >
      <el-input
          clearable
          style="width: 270px"
          v-model.trim="searchCondition.queryMobileValue"
          placeholder="请输入"
          size="small"
          class="ipt mr10"
      >
        <el-select
            slot="prepend"
            size="small"
            style="width: 110px"
            v-model="searchCondition.queryMobileType"
        >
          <el-option label="会员手机号" value="memberMobile"></el-option>
          <el-option label="收货人手机号" value="receiverMobile"></el-option>
        </el-select>
      </el-input>
      <el-input
          clearable
          style="width: 270px"
          v-model.trim="searchCondition.querySnValue"
          placeholder="请输入"
          size="small"
          class="ipt mr10"
      >
        <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            v-model="searchCondition.querySnType"
        >
          <el-option label="订单号" value="receiptSn"></el-option>
          <el-option label="发货单号" value="deliverSn"></el-option>
          <el-option label="提货码" value="billNo"></el-option>
        </el-select>
      </el-input>
      <el-input
          clearable
          style="width: 270px"
          v-model.trim="searchCondition.queryGoodsValue"
          placeholder="请输入"
          size="small"
          class="ipt mr10"
      >
        <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            v-model="searchCondition.queryGoodsType"
        >
          <el-option label="商品名称" value="goodsName"></el-option>
          <el-option label="货号" value="goodsSn"></el-option>
          <el-option label="条码" value="barCode"></el-option>
        </el-select>
      </el-input>
      <el-cascader
        v-model="searchCondition.categoryId"
        :show-all-levels="false"
        size="small"
        class="mr10 flex-1"
        :props="categoryFuncs"
        clearable
        placeholder="请选择类目"
      ></el-cascader>
    </div>
    <div  class="flex-1 text-left mb20">

      <!-- <el-input
        clearable
        v-model.trim="searchCondition.keyword"
        placeholder="请输入下单/收货手机号"
        size="small"
        style="width:180px;"
        class="mr10"
      ></el-input> -->
      <!-- <el-input
        clearable
        v-model.trim="searchCondition.queryKey"
        placeholder="请输入订单号/发货单号/提货码"
        size="small"
        style="width:230px;"
        class="mr10"
      ></el-input> -->
      <el-select
          clearable
          v-model="searchCondition.deliveryType"
          placeholder="选择配送方式"
          size="small"
          filterable
          class="mr10"
      >
        <el-option label="门店自提" value="mdzt"></el-option>
        <el-option label="快递发货" value="kdfh"></el-option>
        <el-option label="同城配送" value="tcps"></el-option>
      </el-select>
      <el-select
          clearable
          size="small"
          filterable
          class="mr10"
          v-model="searchCondition.shopId"
          placeholder="请选择所属门店"
          v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
      >
        <el-option
            v-for="(item, i) in expressShopList"
            :key="i"
            :label="item.shopName"
            :value="item.shopId"
        >
        </el-option>
      </el-select>
      <el-select
          clearable
          size="small"
          filterable
          class="mr10"
          v-model="searchCondition.shopId"
          placeholder="请选择所属门店"
          v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
      >
        <el-option
            v-for="(item, i) in dkShops"
            :key="i"
            :label="item.shopName"
            :value="item.shopId"
        >
        </el-option>
      </el-select>

      <!-- <el-input
        clearable
        v-model.trim="searchCondition.deliverSn"
        placeholder="请输入发货单号"
        size="small"
        class="mr10"
      ></el-input>
      <el-input
        clearable
        v-model.trim="searchCondition.expressOrderSn"
        placeholder="请输入快递单号"
        size="small"
        class="mr10"
      ></el-input> -->

      <el-date-picker
          style="width: 300px"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          start-placeholder="请选择下单时间段"
          end-placeholder="请选择下单时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class="mr10 time"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '自发货列表')"
          :loading="isOutputing"
      >导出</el-button
      >
    </div>

    <div
        class="flex flex-between"
        v-if="searchCondition.expressSendMode === 'self'"
    >
      <div class="flex item-center">
        <el-radio-group
            v-model="receiptsTemplate"
            size="small"
            @change="printTypeChange"
        >
          <el-tooltip
              effect="dark"
              content="竖版发货单为小票模板"
              placement="top"
          >
            <el-radio label="vertical">打印竖版发货单模板</el-radio>
          </el-tooltip>
          <el-tooltip
              effect="dark"
              content="横板发货单为A4模板"
              placement="top"
          >
            <el-radio label="cross">打印横板发货单模板(A4)</el-radio>
          </el-tooltip>
        </el-radio-group>
      </div>
      <div class="mt10" v-if="searchCondition.timeStatus === 'daipeihuo'">
        <span class="form-red">
          如果系统配了快递云打印功能，点击去配货则同时打印发货单和快递单
        </span>
        <span
            class="pointer mr10"
            @click="batchSetting"
            style="font-size: 25px; color: red"
        >
          <span
              class="hmicon icon-jianhuopeihuo"
              style="font-size: 25px"
          ></span>
          批量打印发货单
        </span>
      </div>
      <div
          class="mt10"
          v-if="
          searchCondition.timeStatus === 'daifahuo' ||
            searchCondition.timeStatus === 'guaqi'
        "
      >
        <span
            class="pointer mr10"
            @click="batchDelivery"
            style="font-size: 25px; color: red"
        >
          <span class="hmicon icon-piliangfahuo" style="font-size: 25px"></span>
          去发货
        </span>
      </div>
    </div>
    <div
        v-if="searchCondition.expressSendMode === 'third'"
        class="flex flex-between mb10"
    >
      <div>
        <el-button type="primary" class="delete open-file" size="small"
        >导入并发货
          <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </el-button>
        <el-button
            type="primary"
            size="small"
            @click="outputThird('queryAllThirdList', '三方发货列表')"
            :loading="isOutputing"
        >导出发货表</el-button
        >
      </div>
      <div>
        <el-input
            clearable
            v-model.trim="searchCondition.querySnValue"
            placeholder="请输入订单号"
            size="small"
            style="width: 270px"
            class="mr10"
        ></el-input>
        <el-select
            size="small"
            filterable
            class="mr10"
            clearable
            v-model="searchCondition.supplierId"
            placeholder="请选择发货商"
        >
          <el-option
              v-for="(item, i) in supplierInfoList"
              :key="i"
              :label="item.supplierName"
              :value="item.supplierId"
          >
          </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>

    <div class="table">
      <el-table
          stripe
          border
          ref="table"
          @selection-change="getChecked"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
          :key="Math.random()"
      >
        <el-table-column
            type="selection"
            v-if="searchCondition.timeStatus === 'daipeihuo'"
        ></el-table-column>
        <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="deliverSn"
            label="发货单号"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="receiptSn"
            label="订单号"
        >
          <template slot-scope="scope">
            <div class="blue pointer" @click="details(scope.row)">
              {{ scope.row.receiptSn }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="deliveryType"
            label="配送方式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.deliveryType === 'mdzt'">门店自提</span>
            <span v-if="scope.row.deliveryType === 'kdfh'">快递发货</span>
            <span v-if="scope.row.deliveryType === 'tcps'">同城配送</span>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="发货门店"
            v-if="searchCondition.expressSendMode === 'self'"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="supplierName"
            label="三方发货商"
            v-if="searchCondition.expressSendMode === 'third'"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="purchaseTime"
            label="下单时间"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="statusTime"
            label="发货时间"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="expressOrderSn"
            label="快递单号"
        >
          <template slot-scope="scope">
            <div v-if="searchCondition.timeStatus === 'daipeihuo'">-</div>
            <div
                v-else
                :class="scope.row.expressOrderSnOld === '' ? 'pointer blue' : ''"
                @click="editExpressOrderSn(scope.row)"
            >
              {{ scope.row.expressOrderSn
              }}<span
                class="hmicon icon-shuru"
                v-if="
                  scope.row.expressOrderSn !== '' &&
                    scope.row.expressOrderSnOld === ''
                "
            ></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="remark"
            label="商品备注"
            width="140"
        >
          <template slot-scope="scope">
            <el-input
                @blur="remarkBlur(scope.row)"
                @focus="remarkFocus(scope.row)"
                style="height: 100%"
                class="remark-tarea"
                size="small"
                type="textarea"
                clearable
                placeholder="请输入商品备注"
                maxlength="128"
                v-model="scope.row.remark"
            ></el-input>
            <!-- {{ scope.row.printNum }} -->
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="goodsNames"
            label="发货商品"
            width="250"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <div v-html="scope.row.tooltipGoodsName"></div>
              </div>
              <div class="oneLine">{{ scope.row.goodsNames }}</div>
            </el-tooltip>
            <!-- {{ scope.row.goodsNames }} -->
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="printNum"
            label="打印次数"
        >
          <template slot-scope="scope">
            {{ scope.row.printNum }}
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="receiptCount"
            label="是否拆单"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptCount > 1 ? "已拆单" : "未拆单" }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="expressOrderSn"
          label="快递单号"
        >
          <template slot-scope="scope" v-if="scope.row.deliveryType === 'kdfh'">
            <span v-if="searchCondition.timeStatus === 'yifahuo'">{{
              scope.row.expressOrderSn
            }}</span>
            <el-input
              v-else
              :disabled="scope.row.disabled"
              @keyup.enter.native="submitOrderSn(scope.row)"
              v-model="scope.row.expressOrderSn"
              clearable
              style="width:150px;"
              placeholder="请扫描快递单号"
              size="small"
              class="ipt mr10"
            ></el-input>
          </template>
        </el-table-column> -->

        <el-table-column
            header-align="center"
            align="center"
            prop="orderState"
            label="当前状态"
            v-if="searchCondition.timeStatus === 'yifahuo'"
        >
          <template slot-scope="scope">
            <span
                class="status blue"
                v-if="scope.row.orderState === 'deliverOrder'"
            >{{
                scope.row.deliveryType === "mdzt"
                    ? "等待门店自提"
                    : "等待确认收货"
              }}</span
            >
            <span
                class="status blue"
                v-if="scope.row.orderState === 'takeOrder'"
            >{{
                scope.row.deliveryType === "mdzt" ? "已提货" : "已确认收货"
              }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
            v-else
            label="操作"
            header-align="center"
            align="center"
            width="200"
        >
          <template slot-scope="scope">
            <div
                class="flex flex-center"
                v-if="searchCondition.expressSendMode === 'self'"
            >
              <div>
                <el-button
                    size="small"
                    type="text"
                    @click="printCourierReceipt(scope.row)"
                    v-if="
                    scope.row.deliveryType === 'kdfh' &&
                      searchCondition.timeStatus === 'daifahuo'
                  "
                >补打快递单</el-button
                >
                <el-button
                    size="small"
                    type="text"
                    v-if="searchCondition.timeStatus === 'daifahuo' || searchCondition.timeStatus === 'guaqi'"
                    @click="printInvoice(scope.row)"
                >补打发货单</el-button
                >
                <el-button
                    size="small"
                    type="text"
                    v-if="
                    searchCondition.timeStatus === 'daifahuo' &&
                      scope.row.hasOwnProperty('thirdCode')
                  "
                    @click="sendThird(scope.row)"
                >{{
                    scope.row.sendToDaDaStates
                        ? "查看三方配送详情"
                        : "发单给三方平台"
                  }}
                </el-button>

                <!-- <el-button
                    size="small"
                    type="text"
                    v-if="
                    searchCondition.timeStatus === 'daifahuo' &&
                      scope.row.hasOwnProperty('thirdCode')
                  "
                    @click="sendThird(scope.row)"
                >{{
                    scope.row.sendToDaDaStates
                        ? "查看三方配送详情"
                        : "发单给三方平台"
                  }}
                </el-button> -->

                <!-- <el-button
                  size="small"
                  type="text"
                  @click="scan(scope.row)"
                  v-if="
                    scope.row.deliveryType === 'kdfh' &&
                      searchCondition.timeStatus === 'daifahuo'
                  "
                  >重扫快递单</el-button
                > -->
                <div>
                  <el-button
                      size="small"
                      type="text"
                      @click="single(scope.row)"
                      v-show="scope.row.deliveryType !== 'mdzt'"
                      v-if="
                      isBtn('fendan:false') && scope.row.deliveryType !== 'mdzt'
                    "
                  >分单</el-button
                  >
                  <el-button
                      size="small"
                      type="text"
                      @click="assigned(scope.row)"
                      v-if="isBtn('zhipai:false')"
                  >指派</el-button
                  >
                  <el-button
                      size="small"
                      type="text"
                      @click="hang(scope.row)"
                      v-if="searchCondition.timeStatus !== 'guaqi'"
                  >挂起</el-button
                  >
                </div>
              </div>
            </div>
            <div class="flex flex-center" v-else>
              <el-button
                  v-if="searchCondition.timeStatus == 'daifahuo'"
                  size="small"
                  type="text"
                  @click="confirmDelivery(scope.row)"
              >确认发货</el-button
              >
              <el-button
                  v-if="searchCondition.timeStatus == 'guaqi'"
                  size="small"
                  type="text"
                  @click="removeHang(scope.row)"
              >解除挂起</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            header-align="center"
            align="center"
            v-if="searchCondition.timeStatus === 'yifahuo'"
            width="150px"
        >
          <template slot-scope="scope">
            <el-button
                size="small"
                type="text"
                v-if="scope.row.hasOwnProperty('thirdCode')"
                @click="sendThird(scope.row)"
            >查看三方配送详情
            </el-button>

            <el-button v-if="scope.row.deliveryType === 'tcps' " type="primary" size="small" @click="reAddOrder(scope.row)">重新呼叫骑手</el-button>

          </template>

        </el-table-column>
        <template slot="empty">
          <div class="empty">
            <img class="img_no" src="../../assets/n001.jpg" alt="" />
            <p class="empty_tex">请设置查询条件后查询</p>
          </div>
        </template>
      </el-table>
      <!-- <div class="no_data" v-if="list">阿尔法恩爱分案说法 </div> -->
    </div>
    <div class="hm-pagination">
      <el-pagination
          background
          :total="total"
          @current-change="paging"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        :width="receiptsTemplate === 'cross' ? '720px' : '240px'"
        :before-close="cancel"
        title="订单详情"
    >
      <div class="content">
        <div
            class="flex flex-end"
            style="padding-right: 20px; padding-top: 10px"
        >
          <div>
            <el-button type="primary" size="small" @click="printTe" id="btn"
            >打印</el-button
            >
          </div>
        </div>
        <div ref="cross" v-if="receiptsTemplate === 'cross'">
          <div
              v-for="(newDetailsOrder, i) in orderPrintList"
              :key="i"
              style="page-break-after: always"
          >
            <ul class="info-lists" id="printTest">
              <li class="mb10">
                <div class="flex flex-between tit">
                  <div class="flex-1 flex flex-warp">
                    <div
                        class="logoImg"
                        style="width: 92px; height: 92px; paddingright: 20px"
                    >
                      <img
                          style="width: 100px; height: 100%"
                          :src="querySupplier.logoPath"
                          alt=""
                      />
                    </div>
                    <div class="sh-info ml20">
                      <div class="sh-name">
                        {{ querySupplier.storeName }}
                      </div>
                      <div class="sh-xinxi">
                        {{ querySupplier.storeAddress }}
                      </div>
                      <div class="sh-xinxi">
                        电话：{{ newDetailsOrder.shopPhone }}
                      </div>
                    </div>
                  </div>
                  <vue-barcode
                      :value="newDetailsOrder.order.deliverSn"
                      :options="barcode_option"
                      tag="svg"
                  ></vue-barcode>
                </div>
              </li>
              <li class="mb20">
                <div class="consignee">
                  <div style="fontweight: 700">
                    流水号:{{ newDetailsOrder.order.serialNumber }}
                  </div>
                  <div
                      style="fontweight: 700"
                      v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                  >
                    配送方式:门店自提
                  </div>
                  <div
                      style="fontweight: 700"
                      v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                  >
                    配送方式:快递发货
                  </div>
                  <div
                      style="fontweight: 700"
                      v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                  >
                    配送方式:同城配送
                  </div>
                  <div>订单编号：{{ newDetailsOrder.order.receiptSn }}</div>

                  <div style="fontweight: 600">收货人信息</div>
                  <div>收货人：{{ newDetailsOrder.order.receiverName }}</div>
                  <div>
                    手机号码：{{ newDetailsOrder.order.receiverMobile }}
                  </div>
                  <div>邮政编码：{{ newDetailsOrder.order.spuName }}</div>
                  <div>
                    收货地址：{{ newDetailsOrder.order.deliveryProvince
                    }}{{ newDetailsOrder.order.deliveryAddress }}
                  </div>
                </div>
                <div class="consignee">
                  <div>
                    会员名称：{{ newDetailsOrder.order.memberName }}
                    <span v-if="newDetailsOrder.order.nickName"
                    >({{ newDetailsOrder.order.nickName }})</span
                    >
                  </div>
                  <div>会员电话：{{ newDetailsOrder.order.memberMobile }}</div>
                  <div>下单时间：{{ newDetailsOrder.order.purchaseTime }}</div>
                  <div>支付时间：{{ newDetailsOrder.order.payTime }}</div>
                  <div>
                    支付方式：
                    <span
                        class="primary"
                        v-if="newDetailsOrder.order.payMode === 'no_pay'"
                    >未支付</span
                    >
                    <span
                        class="primary"
                        v-if="newDetailsOrder.order.payMode === '0_pay'"
                    >0元订单</span
                    >
                    <span
                        class="primary"
                        v-if="newDetailsOrder.order.payMode === 'wx_pay'"
                    >微信支付</span
                    >
                  </div>
                </div>
              </li>
              <li class="mb20">
                <div class="modal-table">
                  <div class="table-header flex">
                    <div class="flex-3 flex flex-center">商品名称/品牌</div>
                    <div class="flex-1 flex flex-center">价格/货号</div>
                    <div class="flex-1 flex flex-center">活动</div>
                    <div class="flex-1 flex flex-center">规格</div>
                    <div class="flex flex-center" style="width: 30px">数量</div>
                    <div class="flex-1 flex flex-center">小计</div>
                  </div>
                  <div
                      class="table-body flex"
                      :class="{ tuikuan: v.returnType !== 'no' }"
                      v-for="(v, i) in newDetailsOrder.orderGoods"
                      :key="i"
                  >
                    <img
                        class="warning-tuikuan"
                        v-show="v.returnType === 'yes'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                        alt=""
                    />
                    <img
                        class="warning-tuikuan"
                        v-show="v.returnType === 'doing'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                        alt=""
                    />
                    <div class="flex-3 flex flex-center flex-column">
                      <div
                          class="flex flex-center item-center"
                          v-if="v.returnType !== 'no'"
                          style="
                          opacity: 0.3;
                          position: absolute;
                          left: 0;
                          top: 0;
                          bottom: 0;
                        "
                      >
                        <!-- 仅退款 -->
                        <img
                            v-if="v.refundReturnType === 'money'"
                            style="width: 100px; height: 100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                            alt=""
                        />

                        <!-- 退货退款 -->
                        <img
                            v-if="v.refundReturnType === 'refund'"
                            style="width: 100px; height: 100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                            alt=""
                        />

                        <!-- 退运费 -->
                        <img
                            v-if="v.refundReturnType === 'deliver'"
                            style="width: 100px; height: 100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                            alt=""
                        />
                      </div>
                      <div>
                        <p>{{ v.spuName }}</p>
                        <p>品牌: {{ v.brandName }}</p>
                        <el-tag type="warning"
                        >{{
                            v.spuType === "virtual" ? "虚拟" : "实物"
                          }}商品</el-tag
                        >
                      </div>
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      <div>
                        <p>价格: {{ v.totalPrice }}</p>
                        <p>货号: {{ v.goodsSn }}</p>
                        <p>条码: {{ v.barCode }}</p>
                      </div>
                    </div>
                    <!-- <div class="flex-1 flex flex-center flex-column">
                      <div>
                        <p v-if="v.netWeight">净重: {{ v.netWeight }}</p>
                        <p v-if="v.grossWeight">毛重: {{ v.grossWeight }}</p>
                      </div>
                    </div> -->
                    <div class="flex-1 flex flex-center flex-column">
                      {{ v.promotionInfo }}
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      {{ v.specIdGroupName }}
                    </div>
                    <div
                        class="flex flex-center flex-column"
                        style="width: 30px"
                    >
                      {{ v.goodsNum }}
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      {{ v.totalPrice * v.goodsNum }}
                    </div>
                  </div>
                </div>
                <div class="flex flex-end" style="fontweight: 700">
                  商品总数：{{ newDetailsOrder.orderGoodsNum }}
                </div>
              </li>
              <li class="mb20">
                <!-- <div class="modal-table">
                  <div class="table-header flex">
                    <div class="flex-1 flex flex-center">商品合计</div>
                    <div class="flex-1 flex flex-center">运费</div>
                    <div class="flex-1 flex flex-center">优惠券</div>
                    <div class="flex-1 flex flex-center">
                      积分抵扣
                    </div>
                    <div class="flex-1 flex flex-center">
                      活动优惠
                    </div>
                    <div class="flex-1 flex flex-center">
                      实付金额
                    </div>
                    <div class="flex-1 flex flex-center">
                      应付金额
                    </div>
                  </div>
                  <div class="table-body flex">
                    <div class="flex-1 flex flex-center">
                      ￥{{ newDetailsOrder.order.totalPrice }}
                    </div>
                    <div class="flex-1 flex flex-center">
                      {{ newDetailsOrder.order.deliverMoney }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      -￥{{ newDetailsOrder.order.couponMoney }}
                    </div>
                    <div class="flex-1 flex flex-center">
                      {{ newDetailsOrder.order.spuName }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      -￥{{ newDetailsOrder.order.activeMoney }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      ￥{{ newDetailsOrder.order.actuallyPrice }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      ￥{{ newDetailsOrder.order.payPrice }}
                    </div>
                  </div>
                </div> -->
                <div class="mt10 consignee" style="lineheight: 30px">
                  备注：
                  <span style="font-size: 30px">{{
                      newDetailsOrder.order.orderRemark
                    }}</span>
                </div>
              </li>
              <li class="mb30 ml10">
                <div class="mb20">
                  制单人：_________ 配货人：_________ 验货人：_________
                  收银员：_________
                </div>
                <div class="mb10">
                  录单人：_________ 送货人：_________ 顾客：_________
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div ref="vertical" v-if="receiptsTemplate === 'vertical'">
          <div
              v-for="(newDetailsOrder, i) in orderPrintList"
              :key="i"
              style="page-break-after: always"
              class="content"
          >
            <ul class="info-lists" ref="print" id="printTest">
              <li>
                <div class="flex flex-center">
                  <vue-barcode
                      :value="newDetailsOrder.order.deliverSn"
                      :options="barcode_option"
                      tag="svg"
                  ></vue-barcode>
                </div>
              </li>
              <li class="mb20">
                <div class="title">基本信息</div>

                <div class="mb20">
                  <div style="fontweight: 700" class="fz mb10">
                    流水号:{{ newDetailsOrder.order.serialNumber }}
                  </div>
                  <div class="fz mb10">
                    会员名称：{{ newDetailsOrder.order.memberName }}
                    <span v-if="newDetailsOrder.order.nickName"
                    >({{ newDetailsOrder.order.nickName }})</span
                    >
                  </div>
                  <div class="fz mb10">
                    会员电话：{{ newDetailsOrder.order.memberMobile }}
                  </div>
                  <div class="fz mb10">
                    订单号：{{ newDetailsOrder.order.receiptSn }}
                  </div>
                  <div class="fz mb10">
                    购物人：{{ newDetailsOrder.order.receiverName }}
                  </div>
                  <div class="fz mb10">
                    收货人手机号：{{ newDetailsOrder.order.receiverMobile }}
                  </div>
                  <div
                      class="fz mb10"
                      v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                  >
                    配送方式：门店自提
                  </div>
                  <div
                      class="fz mb10"
                      v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                  >
                    配送方式：快递发货
                  </div>
                  <div
                      class="fz mb10"
                      v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                  >
                    配送方式：同城配送
                  </div>

                  <div class="fz mb10">
                    付款时间：{{ newDetailsOrder.order.payTime }}
                  </div>
                  <div class="fz mb10">付款方式：微信支付</div>
                  <div class="fz mb10">
                    商城门店：{{ newDetailsOrder.order.shopName }}
                  </div>
                  <div class="fz mb10">
                    收货地址：{{ newDetailsOrder.order.deliveryProvince
                    }}{{ newDetailsOrder.order.deliveryAddress }}
                  </div>
                </div>
              </li>
              <li class="mb10">
                <div class="title">商品信息</div>
                <div
                    class="fz mb30"
                    v-for="(v, i) in newDetailsOrder.orderGoods"
                    :class="{ wrongs: v.returnType !== 'no' }"
                    :key="i"
                >
                  <div>
                    <img
                        v-show="v.returnType === 'yes'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                        alt=""
                    />
                    <img
                        v-show="v.returnType === 'doing'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                        alt=""
                    />
                  </div>
                  <div class="mb5">
                    <p class="mb5">商品名称:{{ v.spuName }}</p>
                  </div>
                  <p class="mb5">活动:{{ v.promotionInfo }}</p>
                  <p class="mb5">品牌:{{ v.brandName }}</p>
                  <p class="mb5">规格:{{ v.specIdGroupName }}</p>
                  <p class="mb5">条码: {{ v.barCode }}</p>
                  <p class="mb5">数量:{{ v.goodsNum }}</p>
                  <p class="mb5">原价:{{ v.totalPrice }}</p>
                  <p class="mb5">实付:{{ v.payPrice }}</p>
                </div>
                <div class="fz mb10" style="fontweight: 700">
                  商品总数：{{ newDetailsOrder.orderGoodsNum }}
                </div>
                <hr />
                <div class="fz mb20">
                  配送费：{{ newDetailsOrder.order.deliverMoney }}
                </div>
                <div class="fz mb20">
                  优惠券：{{ newDetailsOrder.order.couponMoney }}
                </div>
                <div class="fz" style="height: 30px">
                  合计：{{ newDetailsOrder.order.payPrice }}
                </div>
              </li>
              <li v-if="newDetailsOrder.order.orderRemark">
                <div class="title">备注</div>
                <div style="font-size: 20px">
                  备注：{{ newDetailsOrder.order.orderRemark }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="close" size="small" type="primary">关闭</el-button>
      </span> -->
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleOrder"
        :title="title"
        :width="shippingType === 'confirmDelivery' ? '' : '1400px'"
        :before-close="cancel"
    >
      <div v-if="shippingType === 'confirmDelivery'">
        <div class="mb20">
          <el-radio-group v-model="deliveryWay" size="small">
            <el-radio label="one">单包发货</el-radio>
            <el-radio label="subcontract">分包发货</el-radio>
          </el-radio-group>
        </div>

        <div style="color: #222" v-if="deliveryWay === 'one'">
          快递单号:
          <el-input
              clearable
              v-model="isDeliverSn"
              size="small"
              ref="deliverSn"
              class="ipt mr10"
              style="width: 250px"
              placeholder="请输入快递单号"
          ></el-input>
        </div>
        <div v-if="deliveryWay === 'subcontract'">
          <ul class="info-list">
            <li class="mb20">
              <div class="title">拆分包裹</div>
              <el-table
                  stripe
                  ref="brandTable"
                  class="mb20 modal-table"
                  :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
                  :data="detailsExpressOrder.orderGoods"
                  style="width: 100%"
                  id="table"
                  size="small"
              >
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="商品名称"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    label="货号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsNum"
                    label="订单数量"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="shippingNum"
                    label="发货数量"
                >
                  <template slot-scope="scope">
                    <div v-if="!scope.row.goodsNum"></div>
                    <el-input
                        v-else
                        clearable
                        @input="filterGt0(scope.$index, 'shippingNum')"
                        v-model.trim="scope.row.shippingNum"
                        placeholder="发货数量"
                        size="small"
                        class="ipt mr20"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
              <div style="color: #222" class="mb10">
                快递单号:
                <el-input
                    clearable
                    v-model="isDeliverSn"
                    size="small"
                    ref="deliverSn"
                    class="ipt mr10"
                    style="width: 250px"
                    placeholder="请输入快递单号"
                ></el-input>
              </div>
              <div>
                <el-button type="primary" size="small" @click="breakUp"
                >拆分包裹1</el-button
                >
              </div>
            </li>
            <li class="mb20">
              <div class="title">包裹清单</div>
              <el-table
                  stripe
                  ref="brandTable"
                  class="mb20 modal-table"
                  :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
                  :data="breakList"
                  style="width: 100%"
                  id="table"
                  size="small"
              >
                <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="appointShopName"
                    label="发货门店"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    width="400"
                    label="商品清单"
                >
                  <template slot-scope="scope">
                    <el-tooltip placement="top">
                      <div slot="content">
                        <div v-html="scope.row.goodsNameList"></div>
                      </div>
                      <div class="oneLine">{{ scope.row.goodsNames }}</div>
                    </el-tooltip>
                    <!-- {{ scope.row.goodsNames }} -->
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button
                          size="small"
                          class="danger"
                          type="text"
                          @click="remove(scope.$index, scope.row)"
                      >删除</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex" v-if="shippingType === 'single'">
        <div style="width: 50%">
          <ul class="info-list">
            <li class="mb20">
              <div class="title">订单信息</div>

              <div class="modal-table mb20">
                <div class="table-header flex">
                  <div class="flex-1">订单号</div>
                  <div class="flex-1">下单门店</div>
                </div>
                <div class="table-body flex">
                  <div class="flex-1">
                    {{ detailsExpressOrder.order.receiptSn }}
                  </div>
                  <div class="flex-1">
                    {{ detailsExpressOrder.order.shopName }}
                  </div>
                </div>
              </div>
            </li>
            <li class="mb20">
              <div class="title">收货人信息</div>
              <el-table
                  stripe
                  ref="brandTable"
                  class="mb20 modal-table"
                  :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
                  :data="[detailsExpressOrder.order]"
                  style="width: 100%"
                  id="table"
                  size="small"
              >
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiverName"
                    label="收货人"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiverMobile"
                    label="手机号码"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="邮政编码"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliveryAddress"
                    label="收货地址"
                    width="300"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                        :content="
                        scope.row.deliveryProvince + scope.row.deliveryAddress
                      "
                        placement="top"
                    >
                      <div class="oneLine">
                        {{ scope.row.deliveryProvince
                        }}{{ scope.row.deliveryAddress }}
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </li>
            <li class="mb20">
              <div class="title">拆分包裹</div>
              <el-table
                  stripe
                  ref="brandTable"
                  class="mb20 modal-table"
                  :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
                  :data="detailsExpressOrder.orderGoods"
                  style="width: 100%"
                  id="table"
                  size="small"
              >
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="商品名称"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    label="货号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsNum"
                    label="订单数量"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="shippingNum"
                    label="发货数量"
                    width="130"
                >
                  <template slot-scope="scope">
                    <div v-if="!scope.row.goodsNum"></div>
                    <el-input
                        v-else
                        clearable
                        type="number"
                        style="width: 100px"
                        @input="filterGt0(scope.$index, 'shippingNum')"
                        v-model.trim="scope.row.shippingNum"
                        placeholder="发货数量"
                        size="small"
                        class="ipt mr20"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
              <el-select
                  clearable
                  size="small"
                  filterable
                  class="mr10"
                  v-model="appointShopId"
                  placeholder="请选择所属门店"
                  v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
              >
                <el-option
                    v-for="(item, i) in expressShopList"
                    :key="i"
                    :label="item.shopName"
                    :value="item.shopId"
                >
                </el-option>
              </el-select>
              <el-select
                  clearable
                  size="small"
                  filterable
                  class="mr10"
                  v-model="appointShopId"
                  placeholder="请选择所属门店"
                  v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
              >
                <el-option
                    v-for="(item, i) in dkShops"
                    :key="i"
                    :label="item.shopName"
                    :value="item.shopId"
                >
                </el-option>
              </el-select>

              <div>
                <el-button type="primary" size="small" @click="breakUp"
                >拆分包裹2</el-button
                >
                <div class="form-item-tip">
                  剩余未拆分的商品将独立成一个发货单，由接单门店发货。
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="width: 50%">
          <ul class="info-list" style="marginleft: 20px">
            <li class="mb20">
              <div class="title">包裹清单</div>
              <el-table
                  stripe
                  ref="brandTable"
                  class="mb20 modal-table"
                  :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
                  :data="breakList"
                  style="width: 100%"
                  id="table"
                  size="small"
              >
                <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="appointShopName"
                    label="发货门店"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    width="400"
                    label="商品清单"
                >
                  <template slot-scope="scope">
                    <el-tooltip placement="top">
                      <div slot="content">
                        <div v-html="scope.row.goodsNameList"></div>
                      </div>
                      <div class="oneLine">{{ scope.row.goodsNames }}</div>
                    </el-tooltip>
                    <!-- {{ scope.row.goodsNames }} -->
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button
                          size="small"
                          class="danger"
                          type="text"
                          @click="remove(scope.$index, scope.row)"
                      >删除</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm" size="small" type="primary"
        >确 定</el-button
        >
        <el-button @click="cancel" type="info" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleShipping"
        :title="titleOrder"
        :before-close="cancel"
    >
      <div v-if="shippingType === 'assigned'">
        <el-select
            clearable
            size="small"
            filterable
            class="mr10"
            v-model="appointShopId"
            placeholder="请选择需要指派发货的门店"
            v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
        >
          <el-option
              v-for="(item, i) in expressShopList"
              :key="i"
              :label="item.shopName"
              :value="item.shopId"
          >
          </el-option>
        </el-select>
        <el-select
            clearable
            size="small"
            filterable
            class="mr10"
            v-model="appointShopId"
            placeholder="请选择需要指派发货的门店"
            v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
        >
          <el-option
              v-for="(item, i) in dkShops"
              :key="i"
              :label="item.shopName"
              :value="item.shopId"
          >
          </el-option>
        </el-select>
        <div class="form-item-tip">
          指派前请线下与对方门店沟通清除，确认无误后再指派。
        </div>
      </div>
      <div v-if="shippingType === 'hang'">
        <div class="flex flex-center">
          <span
              class="hmicon icon-tishi"
              style="font-size: 50px; color: rgb(243, 174, 64)"
          ></span>
        </div>
        <div
            class="flex flex-center mt10"
            style="font-weight: 700; color: #222222; font-size: 16px"
        >
          挂起提醒
        </div>
        <div class="flex flex-center mt10">
          检测到该订单存在第三方发货商品，请确认是否一并挂起第三方发货商品
        </div>
      </div>
      <div v-if="shippingType === 'batchDelivery'">
        <el-image
            class="mb10"
            src="https://imgcdn.hemiao100.com/ThemePictures/fahuotip.png"
        ></el-image>
        <div style="padding: 0 20px" class="mt10">
          <div class="flex flex-center mb20" style="font-size: 20px">
            请使用扫码枪扫描发货单号/提货码
          </div>
          <div class="flex flex-between mb20">
            <div style="font-size: 18px">需发货数量:{{ noNum }}</div>
            <div style="font-size: 18px">已扫描发货:{{ yesNum }}</div>
          </div>
          <div style="font-size: 18px">
            发货扫描:
            <el-input
                clearable
                v-model="isDeliverSn"
                size="small"
                ref="deliverSn"
                class="ipt mr10"
                style="width: 250px"
                placeholder="请扫描/输入发货单号/提货码"
                @keyup.enter.native="submit()"
            ></el-input>
            <el-button
                :disabled="isDeliverSn === ''"
                type="primary"
                size="small"
                @click="submit"
            >确认发货</el-button
            >
          </div>
          <div class="primary mt10" style="marginleft: 81px">
            手动输入请按确认发货按钮或回车键发货
          </div>
          <div class="table info-list mt10" v-if="shippedList.length">
            <div class="title">已发货</div>

            <el-table
                stripe
                border
                :data="shippedList"
                style="width: 100%"
                size="small"
            >
              <el-table-column
                  type="index"
                  label="序号"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="deliverSn"
                  label="发货单号"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="订单号"
              >
                <template slot-scope="scope">
                  <div class="blue pointer" @click="details(scope.row)">
                    {{ scope.row.receiptSn }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="expressOrderSn"
                  label="快递单号"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.expressOrderSn === ''">-</div>
                  <div v-else>
                    {{ scope.row.expressOrderSn }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsNames"
                  label="发货商品"
                  width="300"
              >
                <template slot-scope="scope">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <div v-html="scope.row.goodsNames"></div>
                    </div>
                    <div class="oneLine">{{ scope.row.goodsNames }}</div>
                  </el-tooltip>
                  <!-- {{ scope.row.goodsNames }} -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="flex flex-center mt20">
            <el-button type="primary" size="small" @click="tingZhi"
            >停止批量发货</el-button
            >
          </div>
        </div>
      </div>
      <span
          slot="footer"
          class="dialog-footer flex flex-center"
          v-if="shippingType === 'hang'"
      >
        <el-button @click="allHang" size="small" type="primary"
        >全部挂起</el-button
        >
        <el-button @click="oneselfHang" size="small" type="info"
        >只挂起自发商品</el-button
        >
      </span>
      <span
          slot="footer"
          class="dialog-footer flex flex-center"
          v-if="shippingType !== 'hang' && shippingType !== 'batchDelivery'"
      >
        <el-button @click="confirm" size="small" type="primary"
        >确 定</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="isKuaiDiDan"
        title="缺少快递单"
        width="40%"
    >
      <div style="padding: 0 20px">
        <div class="flex flex-center mb20" style="font-size: 20px">
          该订单缺少快递单，请扫描或手输快递单后发货。
        </div>
        <!-- <div class="flex flex-between mb20">
          <div style="fontSize:18px">需发货数量:{{ noNum }}</div>
          <div style="fontSize:18px">已扫描发货:{{ yesNum }}</div>
        </div> -->
        <div style="font-size: 18px">
          发货扫描:
          <el-input
              clearable
              autofocus="autofocus"
              v-model="expressOrderSn"
              ref="express"
              size="small"
              class="ipt mr10"
              style="width: 250px"
              placeholder="请扫描/输入快递单号"
              @keyup.enter.native="submitExpress()"
          ></el-input>
        </div>
        <div class="primary mt10" style="margin-left: 81px">
          扫描快递单后自动发货，手输快递单号后请按确认发货按钮完成发货。
        </div>
        <div class="flex flex-center mt20">
          <el-button type="primary" size="small" @click="submitExpress"
          >确认发货</el-button
          >
          <el-button size="small" @click="isKuaiDiDan = false">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
        :close-on-click-modal="false"
        width="1200px"
        :visible.sync="dialogOrderDetails"
    >
      <div slot="title">
        <span class="mr10">订单详情</span>
      </div>
      <div class="content">
        <ul class="info-list">
          <li class="mb20">
            <div class="title">基本信息</div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiptSn"
                    label="订单号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="发货单流水号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="memberMobile"
                    label="会员手机号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="payMode"
                    label="支付方式"
                >
                  <template slot-scope="scope">
                    <span
                        class="status danger"
                        v-if="scope.row.payMode === 'no_pay'"
                    >未支付</span
                    >
                    <span
                        class="status danger"
                        v-if="scope.row.payMode === '0_pay'"
                    >0元订单</span
                    >
                    <span
                        class="status danger"
                        v-if="scope.row.payMode === 'wx_pay'"
                    >微信支付</span
                    >
                    <span
                        class="status danger"
                        v-if="scope.row.payMode === 'ali_pay'"
                    >支付支付</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="orderSource"
                    label="订单来源"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderSource === 'wxShop'"
                    >微店订单</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="orderType"
                    label="订单类型"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                    <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
                    <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
                    <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
                    <span v-if="scope.row.orderType === 'smg_faceToFace'"
                    >代客下单-当面收款</span
                    >
                    <span v-if="scope.row.orderType === 'smg_netPush'"
                    >代客下单-网络推送</span
                    >
                    <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
                    <span v-if="scope.row.orderType === 'integral_order'"
                    >积分兑换订单</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliveryType"
                    label="配送方式"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.deliveryType === 'mdzt'"
                    >门店自提</span
                    >
                    <span v-if="scope.row.deliveryType === 'kdfh'"
                    >快递发货</span
                    >
                    <span v-if="scope.row.deliveryType === 'tcps'"
                    >同城配送</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="detailsOrder.order.deliveryType === 'mdzt'"
                    header-align="center"
                    align="center"
                    prop="billNo"
                    label="提货单号"
                ></el-table-column>
                <el-table-column
                    v-else
                    header-align="center"
                    align="center"
                    prop="expressOrderSn"
                    label="物流单号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="自动确认收货时间"
                ></el-table-column>
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopName"
                  label="指定信息"
                ></el-table-column> -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="orderRemark"
                    label="订单备注"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="活动信息"
                ></el-table-column>
              </el-table>
            </div>
          </li>
          <li class="mb20">
            <div class="title">收货人信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiverName"
                  label="收货人"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiverMobile"
                  label="手机号码"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="邮政编码"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="deliveryAddress"
                  label="收货地址"
              >
                <template slot-scope="scope">
                  <span
                  >{{ scope.row.deliveryProvince
                    }}{{ scope.row.deliveryAddress }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">商品信息</div>
            <el-table
                border
                :data="detailsOrder.orderGoods"
                size="small"
                :row-class-name="tableRowClassName"
            >
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsImg"
                  label="商品图片"
              >
                <template slot-scope="scope">
                  <div>
                    <div
                        class="flex flex-center item-center"
                        v-if="scope.row.returnType !== 'no'"
                    >
                      <!-- 仅退款 -->
                      <img
                          v-if="scope.row.refundReturnType === 'money'"
                          style="width: 100px; height: 100px"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                          alt=""
                      />

                      <!-- 退货退款 -->
                      <img
                          v-if="scope.row.refundReturnType === 'refund'"
                          style="width: 100px; height: 100px"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                          alt=""
                      />

                      <!-- 退运费 -->
                      <img
                          v-if="scope.row.refundReturnType === 'deliver'"
                          style="width: 100px; height: 100px"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                          alt=""
                      />
                    </div>
                    <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'yes'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                        alt=""
                    />
                    <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'doing'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                        alt=""
                    />

                    <div
                        class="flex flex-center item-center"
                        :class="
                        scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                      "
                    >
                      <div>
                        <img
                            style="width: 100px; height: 100px"
                            v-if="scope.row.goodsImg"
                            :src="scope.row.goodsImg"
                            alt=""
                        />
                        <div style="width: 100%">
                          <el-tag
                              style="width: 100%"
                              size="mini"
                              effect="plain"
                              type="success"
                              v-if="scope.row.isGift === 'gift'"
                          >赠 品</el-tag
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="商品名称/品牌"
                  width="200"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.spuName }}</p>
                  <p>品牌: {{ scope.row.brandName }}</p>
                  <el-tag
                      style="width: 100%"
                      size="mini"
                      effect="plain"
                      type="success"
                      v-if="scope.row.isGift === 'gift'"
                  >赠 品</el-tag
                  >
                  <el-tag type="warning"
                  >{{
                      scope.row.spuType === "virtual" ? "虚拟" : "实物"
                    }}商品</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="价格/货号"
                  width="200"
              >
                <template slot-scope="scope">
                  <p>价格: {{ scope.row.totalPrice }}</p>
                  <p>货号: {{ scope.row.goodsSn }}</p>
                  <p>条码: {{ scope.row.barCode }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="净重/毛重"
              >
                <template slot-scope="scope">
                  <p v-if="scope.row.netWeight">
                    净重: {{ scope.row.netWeight }}
                  </p>
                  <p v-if="scope.row.grossWeight">
                    毛重: {{ scope.row.grossWeight }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="specIdGroupName"
                  label="规格"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsNum"
                  label="数量"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalPrice"
                  label="小计"
              >
                <template slot-scope="scope">
                  <p>
                    {{ scope.row.totalPrice * scope.row.goodsNum }}
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">费用信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalPrice"
                  label="商品合计"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.totalPrice }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="deliverMoney"
                  label="运费"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.deliverMoney }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="deliverCouponMoney"
                  label="运费券抵扣"
              >
                <template slot-scope="scope">
                  <span class="status primary"
                  >-￥{{ scope.row.deliverCouponMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="couponMoney"
                  label="优惠券"
                  width="220"
              >
                <template slot-scope="scope">
                  <div
                      class="primary"
                      v-for="(v, i) in scope.row.orderCouponInfoModels"
                      :key="i"
                  >
                    {{ v.ruleName }} {{ v.couponCode }}
                  </div>
                  <div class="status primary">
                    -￥{{ scope.row.couponMoney }}
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="积分抵扣"
              >
                --
              </el-table-column> -->
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="activeMoney"
                  label="积分抵扣"
                  v-if="detailsOrder.order.orderType === 'integral_order'"
              >
                <template slot-scope="scope">
                  <span class="status danger"
                  >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="activeMoney"
                  label="活动优惠"
                  v-else
              >
                <template slot-scope="scope">
                  <span class="status danger"
                  >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="activeMoney"
                  label="金豆"
                  v-if="
                  detailsOrder.order.otherPayInfo &&
                    detailsOrder.order.otherPayInfo.length
                "
              >
                <template slot-scope="scope">
                  <div v-for="(v, i) in scope.row.otherPayInfo" :key="i">
                    <div v-if="v.financeCode === 'goldBean'">
                      金豆：已用{{ v.financeValue }}{{ v.relName }}抵用
                      <span class="danger">-￥{{ v.currencyAmount }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="actuallyPrice"
                  label="实付金额"
              >
                <template slot-scope="scope">
                  <div
                      v-if="scope.row.orderType === 'integral_order'"
                      class="status danger"
                  >
                    <span v-if="scope.row.actuallyPrice"
                    >¥{{ scope.row.actuallyPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                  >¥{{ scope.row.actuallyPrice }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="payPrice"
                  label="应付金额"
              >
                <template slot-scope="scope">
                  <div
                      v-if="scope.row.orderType === 'integral_order'"
                      class="status danger"
                  >
                    <span v-if="scope.row.payPrice"
                    >¥{{ scope.row.payPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                  >¥{{ scope.row.payPrice }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
            @click="dialogOrderDetails = false"
            size="small"
            type="primary"
        >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        width="1400px"
        :visible.sync="dialogTest"
    >
      <div class="flex flex-wrap">
        <div class="mr10" style="width: 300">
          <div class="flex flex-center" style="margin-bottom: -50px">
            <img
                style="width: 150px; height: 100px"
                src="https://imgcdn.hemiao100.com/ThemePictures/fenbaolan.png"
                alt=""
            />
          </div>
          <div class="flex flex-between">
            <div class="left-triangle"></div>
            <div class="right-triangle"></div>
          </div>

          <draggable
              class="dragArea list-group bgc p10"
              :list="detailsOrderGoods[0]"
              :group="{ name: 'people', pull: 'clone', put: false }"
              :clone="cloneDog"
              @change="log"
          >
            <div
                class="list-group-item mb10"
                v-for="(v, i) in detailsOrderGoods[0]"
                :key="i"
            >
              <div>
                <div>
                  {{ v.spuName }}
                </div>
                <div class="flex flex-between">
                  <div>规格：{{ v.categoryName }}</div>
                  <div>数量：{{ v.goodsNum }}</div>
                </div>
              </div>
            </div>
          </draggable>
        </div>
        <!-- <div class="flex-1">
          <el-scrollbar
            class="page-x__scroll"
            wrap-style="width:1000px;"
            :vertical="true"
          >
            <div class="flex flex-wrap" style="width:10000px">
              <div v-for="(v, i) in list2" :key="i" style="width:300">
                <div class="list-group">
                  <draggable
                    class="dragArea"
                    :list="v"
                    group="people"
                    @change="log"
                  >
                    <div>
                      {{ v.spuName }}
                    </div>
                    <div class="flex flex-between">
                      <div>规格：{{ v.goodsSn }}</div>
                      <div>数量：{{ v.goodsNum }}</div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div> -->
        <div class="flex-1">
          <el-scrollbar
              class="page-x__scroll"
              wrap-style="width:1000px;"
              :vertical="true"
          >
            <div class="flex flex-wrap" style="width: 10000px">
              <div
                  v-for="(v, i) in detailsOrderGoods"
                  :key="i"
                  style="width: 300"
                  class="mr10"
                  v-if="i !== 0"
              >
                <div class="flex flex-center" style="margin-bottom: -50px">
                  <img
                      style="width: 150px; height: 100px"
                      src="https://imgcdn.hemiao100.com/temp/123/2020-04-29/fenbaolan.png"
                      alt=""
                  />
                </div>
                <div class="flex flex-between">
                  <div class="left-triangle"></div>
                  <div class="right-triangle"></div>
                </div>
                <div class="list-group bgc">
                  <draggable
                      style="width: 200"
                      class="dragArea"
                      :list="v"
                      group="people"
                      @change="log"
                      @start="start"
                      @end="end"
                      :move="move"
                      :animation="200"
                  >
                    <!-- <div
                      v-if="v.length === 0"
                      style="height:60px;color:#F3ACD1;fontWeight:500;fontSize:22px;"
                      class="flex flex-center item-center list-group-item"
                    >
                      请拖入商品
                    </div> -->
                    <div
                        class="list-group-item mb10"
                        v-for="(j, k) in v"
                        :key="k"
                    >
                      <div>
                        {{ j.spuName }}
                      </div>
                      <div class="flex flex-between">
                        <div>规格：{{ j.categoryName }}</div>
                        <div>数量：{{ j.goodsNum }}</div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-button @click="add" size="small" type="primary">添 加</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="修改快递单号"
        :visible.sync="outerVisible"
    >
      <div>
        <div class="form-red">
          快递单号只能够修改一-次， 请仔细核对修改是否正确。
        </div>
        <div class="mb10">当前单号：{{ row.expressOrderSn }}</div>
        <div class="mb10">
          修改单号：<el-input
            clearable
            v-model="expressOrderSn"
            size="small"
            class="ipt mr10"
            max="60"
            style="width: 250px"
            placeholder="输入修改快递单号"
        ></el-input>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="confirmEdit" size="small" type="primary"
          >确认修改</el-button
          >
          <el-button
              @click="
              outerVisible = false;
              expressOrderSn = '';
            "
              size="small"
              type="info"
          >取 消</el-button
          >
        </span>
      </div>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        :title="thirdTitle"
        :visible.sync="sendThirdVisible"
        width="550px"
    >
      <el-dialog
          width="500px"
          title="提示"
          :visible.sync="innerVisible"
          append-to-body
      >
        <el-dialog
            width="500px"
            title="取消成功"
            :visible.sync="cancelVisible"
            append-to-body
        >
          <div class="flex flex-center">
            <div class="yuan text-center">
              <span style="font-size: 50px" class="hmicon icon-duigou"></span>
            </div>
          </div>
          <div class="text-center mt10 suc">
            取消成功，扣除违约金 <span class="danger">{{ deductFee }}</span
          >元!
          </div>
        </el-dialog>
        <div v-if="thirdType === 'send' && cancelType !== 'cancel'">
          <div v-if="thirdState === 'success'">
            <div class="flex flex-center">
              <div class="yuan text-center">
                <span style="font-size: 50px" class="hmicon icon-duigou"></span>
              </div>
            </div>
            <div class="text-center mt10 suc">
              正在呼叫骑手，请等待骑手到店取货!
            </div>
          </div>
          <div v-else>
            <div class="flex flex-center">
              <div class="text-center">
                <span
                    style="font-size: 100px"
                    class="hmicon icon-tishi orange"
                ></span>
              </div>
            </div>
            <div class="text-center mt10 suc">
              呼叫失败，失败原因是：<span class="orange">{{ errMsg }}</span>
            </div>
          </div>
        </div>
        <div v-else-if="thirdType === 'details' && cancelType !== 'cancel'">
          <div style="font-size: 20px" class="flex flex-center">
            <i class="el-icon-phone primary"></i>
            {{ transporterInfo.transporterName
            }}{{ transporterInfo.transporterPhone }}
          </div>
        </div>
        <div v-else-if="thirdType === 'details' && cancelType === 'cancel'">
          <el-form
              ref="cancelReasonInfo"
              :model="cancelReasonInfo"
              :rules="rulesCancel"
              label-width="120px"
          >
            <el-form-item label="取消配送原因：" prop="cancelReasonId">
              <el-select
                  size="small"
                  filterable
                  style="width: 300px"
                  placeholder="请选择配送原因"
                  v-model="cancelReasonInfo.cancelReasonId"
              >
                <el-option
                    :label="v.reason"
                    :value="v.id"
                    v-for="(v, i) in cancelList"
                    :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
                label="输入原因："
                prop="cancelReason"
                v-if="cancelReasonInfo.cancelReasonId == 10000"
            >
              <el-input
                  maxlength="100"
                  placeholder="请输入取消原因"
                  size="small"
                  style="width: 300px"
                  :autosize="{ minRows: 4 }"
                  type="textarea"
                  v-model="cancelReasonInfo.cancelReason"
              ></el-input>
            </el-form-item>
            <div class="form-item-tip">
              接单1 分钟以内取消不扣违约金；<br />
              接单后1－15分钟内取消订单，运费退回。同时扣除2元作为给配送员的违约金；<br />
              配送员接单后15 分钟未到店，商户取消不扣违约金；
            </div>
          </el-form>
        </div>
        <span
            v-if="thirdType === 'details' && cancelType !== 'cancel'"
            slot="footer"
            class="dialog-footer flex flex-center"
        >
          <el-button size="small" type="primary" @click="innerVisible = false"
          >请致电骑手</el-button
          >
        </span>
        <span
            v-if="thirdType === 'details' && cancelType === 'cancel'"
            slot="footer"
            class="dialog-footer flex flex-center"
        >
          <el-button
              size="small"
              type="primary"
              @click="callOff('cancelReasonInfo')"
          >确认</el-button
          >
        </span>
      </el-dialog>
      <el-form
          v-if="thirdType === 'send'"
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="120px"
      >
        <el-form-item label="订单将发货给：" prop="thirdRelationId">
          <el-select
              clearable
              style="width: 248px"
              size="small"
              v-model="ruleForm.thirdRelationId"
              placeholder="请选择三方平台"
              @change="feeChange"
          >
            <el-option
                v-for="(v, i) in codeInfoModelList"
                :key="i"
                :label="v.thirdInterfaceName"
                :value="v.thirdRelationId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="flex mb10">
          <div class="label-third">发货门店：</div>
          {{ ruleForm.shopName }}
        </div>
        <div class="flex mb10">
          <div class="label-third">收货人信息：</div>
          <div>
            <div>{{ ruleForm.receiverName }} {{ ruleForm.receiverMobile }}</div>
            <div>
              {{ ruleForm.deliveryProvince }}
              {{ ruleForm.deliveryAddress }}
            </div>
          </div>
        </div>

        <el-form-item label="商品重量：" prop="cargoWeight">
          <el-input
              style="width: 248px"
              clearable
              type="number"
              v-model="ruleForm.cargoWeight"
              maxlength="20"
              size="small"
              @input="feeChange"
              placeholder="请输入商品重量（用来计算配送费）"
          ></el-input
          >KG
          <el-button
              @click="queryDeliverFee('ruleForm')"
              size="small"
              type="text"
          >计算配送费</el-button
          >
        </el-form-item>
        <el-form-item label="预估配送费为：" prop="">
          <span class="primary" v-if="ruleForm.fee !== ''">{{
              ruleForm.fee * 1 + ruleForm.heMiaoRate * 1
            }}</span>
          <span class="primary" v-if="ruleForm.fee !== ''">元</span>
          <div v-else class="danger">
            <el-button
                @click="queryDeliverFee('ruleForm')"
                size="small"
                type="text"
            >请先计算配送费</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div v-else-if="thirdType === 'details'" class="info-list">
        <div class="mb10">
          当前订单状态为<span class="primary"
        >“{{ transporterInfo.statusMsg }}”</span
        >
        </div>
        <div class="title">配送详情为：</div>
        <div class="ml20">
          <div>{{ transporterInfo.createTime }} 商户发单</div>
          <div v-if="transporterInfo.acceptTime">
            {{ transporterInfo.acceptTime }} 骑手{{
              transporterInfo.transporterName
            }}{{ transporterInfo.transporterPhone }}接单
          </div>
          <div v-if="transporterInfo.fetchTime">
            {{ transporterInfo.fetchTime }} 骑手{{
              transporterInfo.transporterName
            }}{{ transporterInfo.transporterPhone }}取货
          </div>
          <div v-if="transporterInfo.finishTime">
            {{ transporterInfo.finishTime }} 骑手{{
              transporterInfo.transporterName
            }}{{ transporterInfo.transporterPhone }}完成配送
          </div>
          <div v-if="transporterInfo.cancelTime">
            {{ transporterInfo.cancelTime }} 取消配送
          </div>
        </div>
      </div>
      <span
          slot="footer"
          class="dialog-footer flex flex-center"
          v-if="thirdType === 'send'"
      >
        <el-button @click="save('ruleForm')" size="small" type="primary"
        >确认发单呼叫骑手</el-button
        >
        <el-button @click="sendThirdVisible = false" size="small" type="info"
        >取 消</el-button
        >
      </span>
      <span
          slot="footer"
          class="dialog-footer flex flex-center"
          v-else-if="thirdType === 'details'"
      >
        <el-button size="small" type="primary" @click="innerVisible = true"
        >联系骑手</el-button
        >
        <el-button @click="cancels" size="small" type="info"
        >取消配送</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="配送员取消订单"
        :visible.sync="cancelOrderVisible"
        width="550px"
    >
      <div class="text-center">
        <span style="font-size: 100px" class="hmicon icon-tishi orange"></span>
      </div>
      <div class="text-center mt10 suc">
        配送员取消订单，取消原因是：<span class="orange">{{
          cancelTheReason
        }}</span>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="isConfirm('1')" size="small" type="primary"
        >同意取消</el-button
        >
        <el-button @click="isConfirm('0')" size="small" type="info"
        >不同意</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="errVisible"
        width="850px"
    >
      <div slot="title" class="primary">
        以下商品在erp库存不足，无法发货
      </div>
      <div class="text-center mt10">
        {{ errMsg }}
      </div>
      <div
          class="text-center mt10 danger"
          style="font-size:17px;font-weight:bold;"
      >
        请在ERP补足库存后再操作发货;否则将导致订单无法写入ERP销减库存
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="continueShipping" size="small" type="info"
        >仍然发货(稍后到写入异常中处理补写)</el-button
        >
        <el-button @click="errVisible = false" size="small" type="primary"
        >暂不发货(待货品齐全再发货)
        </el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import draggable from "vuedraggable";
import VueBarcode from "@chenfengyuan/vue-barcode";
import { mapGetters } from "vuex";
import { setCookie, getCookie, arrayUnique2 } from "@/utils/utils";
import moment from "moment";

import XLSX from "xlsx";
import {getLoginUser} from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    VueBarcode,
    draggable
  },
  data() {
    return {
      storeCode: "",
      dkShops: [],
      continueType: "",
      continueOrder: [],
      errVisible: false,
      cancelOrderVisible: false,
      cancelTheReason: "",
      transporterInfo: {},
      errMsg: "",
      thirdState: "",
      codeInfoModelList: [],
      basicInfoModel: {},
      thirdType: "",
      thirdTitle: "",
      innerVisible: false,
      sendThirdVisible: false,
      ruleForm: {
        thirdRelationId: "",
        shopName: "",
        receiverName: "",
        receiverMobile: "",
        deliveryProvince: "",
        deliveryAddress: "",
        receiptSn: "",
        payPrice: "",
        shopId: "",
        cargoWeight: "",
        thirdCode: "",
        deliveryNo: "",
        fee: "",
        heMiaoRate: ""
      },
      rules: {
        thirdRelationId: {
          required: true,
          message: "请选择三方平台",
          trigger: "change"
        },
        cargoWeight: {
          required: true,
          message: "请输入商品重量",
          trigger: "blur"
        }
      },
      outerVisible: false,
      list1: [
        { name: "dog 1", id: 1 },
        { name: "dog 2", id: 2 },
        { name: "dog 3", id: 3 },
        { name: "dog 4", id: 4 }
      ],
      list2: [[]],
      dialogTest: false,
      supplierInfoList: [],
      hangupMode: "this",
      row: {},
      appointShopId: "",
      dialogOrderDetails: false,
      deliveryWay: "one",
      expressOrderSn: "",
      isKuaiDiDan: false,
      isDeliverSn: "",
      barcode_option: {
        displayValue: true,
        height: "50px"
      },
      querySupplier: {},
      orderPrintList: [
        {
          orderGoods: [],
          order: {
            deliverSn: ""
          }
        }
      ],
      // newDetailsOrder: {
      //   order: {
      //     receiptSn: ""
      //   }
      // },
      shippingType: "",
      belongShopId: "",
      titleOrder: "",
      title: "",
      dialogVisibleShipping: false,
      dialogVisibleOrder: false,
      dialogVisible: false,
      isOutputing: false,
      receiptsTemplate: "cross",
      searchCondition: {
        expressSendMode: "self",
        timeStatus: "daipeihuo",
        queryMobileType: "memberMobile",
        querySnType: "receiptSn",
        querySnValue: "",
        queryMobileValue: "",
        queryGoodsType: "goodsName",
        queryGoodsValue: "",
        applyDate: [],
        deliveryType: "",
        queryKey: "",
        supplierId: "",
        shopId: "",
      },
      expressShopList: [],
      noDelivery: 0,
      noExpress: 0,
      isExpress: 0,
      guaqiNum: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      breakList: [],
      checkedRow: [],
      noNum: 0,
      yesNum: 0,
      orderRow: {},
      currentProp: {},
      activePreviewIndex: "",
      detailsOrderGoods: [],
      shippedList: [],
      printNumType: "",
      printNumRow: {},
      goodsRow: {},
      cancelList: [],
      cancelReasonInfo: {
        cancelReasonId: "",
        cancelReason: ""
      },
      rulesCancel: {
        cancelReasonId: {
          required: true,
          message: "请选择三方平台"
        },
        cancelReason: {
          required: true,
          message: "请输入取消原因"
        }
      },
      cancelType: "",
      deductFee: 0,
      cancelVisible: false,
      jsonStr: "",
      categoryFuncs: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
    };
  },
  computed: mapGetters(["detailsExpressOrder", "detailsOrder", "dkMicroShopStoreList"]),
  watch: {},
  created() {
    const startTime = moment()
        .subtract(3, "days")
        .format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.applyDate = [
      startTime,endTime
    ];

    this.getParamsCookie();
    if (this.$route.query.type) {
      this.searchCondition.timeStatus = this.$route.query.type;
    }
    if (this.$route.query.receiptSn && this.$route.query.expressSendMode){
      this.searchCondition.expressSendMode = this.$route.query.expressSendMode;
      if(this.$route.query.expressSendMode === 'self'){
        this.searchCondition.timeStatus = "daipeihuo"; 
      }else{
        this.searchCondition.timeStatus = "daifahuo";
      }
      this.searchCondition.querySnValue = this.$route.query.receiptSn;
      this.searchCondition.applyDate = [
        moment(JSON.parse(this.$route.query.purchaseTime)).format("YYYY-MM-DD 00:00:00"),
        moment(JSON.parse(this.$route.query.purchaseTime)).format("YYYY-MM-DD 23:59:59")
      ];
      this.search(); 
    }
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      let res = this.$store.dispatch("queryDkMicroStoreList");
      if (res) {
        res.then((r) => {
          if (r.result) {
            r.result.filter(v=>{
              if (v.shopId != "直营店" && v.shopId != "加盟店" ) {
                this.dkShops.push(v);
              }
            })
          }
        });
      }
    } else {
      this.queryAllShopList();
    }
    this.querySupplierInfoComboBox();
    // this.queryList();
  },
  methods: {
    continueShipping() {
      this.continueExpressPut();
    },
    async continueExpressPut() {
      this.continueOrder[0].still = true;
      await this.$store.dispatch("expressPut", this.continueOrder);
      this.$message({
        message: "发货成功!",
        type: "success"
      });
      this.errVisible = false;
      if (this.continueType === "submitForm") {
        this.dialogVisibleOrder = false;
        this.resetRuleForm();
        this.queryList();
      } else if (this.continueType === "submitExpress") {
        this.isKuaiDiDan = false;
        this.$nextTick(() => {
          this.$refs.deliverSn.focus();
        });
        this.noNum = this.noNum - 1;
        this.yesNum = this.yesNum + 1;
        this.isDeliverSn = "";
        this.expressOrderSn = "";
        this.queryList();
        this.shippedList.unshift(this.orderRow);
        if (this.noNum === 0) {
          this.dialogVisibleShipping = false;
          this.searchCondition.timeStatus = "daifahuo";
          this.queryList();
        }
      } else if (this.continueType === "queryKeywordOrderList") {
        this.noNum = this.noNum - 1;
        this.yesNum = this.yesNum + 1;
        this.isDeliverSn = "";
        this.queryList();
        this.shippedList.unshift(...this.continueOrder);
        if (this.noNum === 0) {
          this.dialogVisibleShipping = false;
          this.searchCondition.timeStatus = "daifahuo";
          this.queryList();
        }
      }
    },
    async isConfirm(isConfirm) {
      const { code } = await this.$store.dispatch(
          "storeShopInfoMessageConfirm",
          {
            isConfirm,
            jsonStr: this.jsonStr,
            receiptSn: this.row.receiptSn
          }
      );
      if (code === "0") {
        this.$message({
          message: "操作成功!",
          type: "success"
        });
        this.cancelOrderVisible = false;
        this.queryList();
      }
    },
    async cancels() {
      const { code, result } = await this.$store.dispatch(
          "queryCancelReasons",
          {
            receiptSn: this.row.receiptSn
          }
      );
      if (code === "0") {
        this.cancelType = "cancel";
        this.cancelList = result;

        setTimeout(() => {
          this.$refs.cancelReasonInfo.resetFields();
        }, 10);
        this.cancelReasonInfo.cancelReasonId = "";
        this.cancelReasonInfo.cancelReason = "";
        this.innerVisible = true;
      }
    },
    feeChange() {
      this.ruleForm.fee = "";
    },
    callOff(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.cancelReasonInfo));
          params.receiptSn = this.row.receiptSn;
          this.$store.dispatch("cancelDaDaOrder", params).then(res => {
            const { code, result } = res;

            if (code === "0") {
              this.innerVisible = false;
              this.sendThirdVisible = false;
              this.cancelVisible = true;
              this.deductFee = result.deduct_fee;
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    queryDeliverFee(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          this.$store.dispatch("queryDeliverFee", params).then(res => {
            const { code, result } = res;
            if (code === "0") {
              this.ruleForm.fee = result.fee;
              this.ruleForm.heMiaoRate = result.heMiaoRate;
              this.ruleForm.deliveryNo = result.deliveryNo;
            }
          });
        } else {
          return false;
        }
      });
    },
    save(ruleForm) {
      if (this.ruleForm.fee !== "") {
        this.$refs[ruleForm].validate(valid => {
          if (valid) {
            try {
              let params = JSON.parse(JSON.stringify(this.ruleForm));
              this.$store.dispatch("addAfterQuery", params).then(res => {
                const { code, result, errMsg } = res;

                if (code === "0") {
                  if (result === "success") {
                    this.sendThirdVisible = false;
                  } else {
                    this.errMsg = errMsg;
                  }
                  this.thirdState = result;
                  this.innerVisible = true;
                  this.queryList();
                }
              });
            } catch (error) {
              console.log("error: ", error);
            }
          } else {
            return false;
          }
        });
      } else {
        this.$message({
          message: "请先计算配送费",
          type: "warning"
        });
      }
    },
    resetForm(formName) {
      setTimeout(() => {
        this.$refs[formName].resetFields();
      }, 0);
      // for (let key in this[formName]) {
      //   this[formName][key] = "";
      // }
    },
    async sendThird(row) {
      this.row = row;
      this.cancelType = "";
      if (row.sendToDaDaStates) {
        this.thirdTitle = "查看三方配送详情";
        this.thirdType = "details";
        const { code, result } = await this.$store.dispatch(
            "queryOrderStatus",
            {
              receiptSn: row.receiptSn
            }
        );
        if (code === "0") {
          if (!result.isMessageConfirm) {
            this.sendThirdVisible = true;
            this.transporterInfo = result;
          } else {
            this.cancelOrderVisible = true;
            this.jsonStr = result.json;
            this.cancelTheReason = JSON.parse(
                JSON.parse(result.json).messageBody
            ).cancelReason;
          }
        }
      } else {
        this.thirdTitle = "发单给三方平台";
        this.thirdType = "send";
        const { code, result } = await this.$store.dispatch("queryOrderInfo", {
          receiptSn: row.receiptSn
        });

        if (code === "0") {
          this.sendThirdVisible = true;
          this.resetForm("ruleForm");
          this.ruleForm.fee = "";
          const { codeInfoModelList, basicInfoModel } = result;
          basicInfoModel.shopId = basicInfoModel.belongShopId;
          for (let key in basicInfoModel) {
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = basicInfoModel[key];
            }
          }
          this.codeInfoModelList = codeInfoModelList;
        }
      }
    },

    remarkFocus(row) {
      this.goodsRow = JSON.parse(JSON.stringify(row));
    },
    async remarkBlur(row) {
      // if (row.remark !== "" && row.remark !== null) {
      if (this.goodsRow.remark !== row.remark) {
        const { code } = await this.$store.dispatch("editGoodsRemark", row);
        if (code === "0") {
          this.queryList();
        }
      }
      // }
    },
    printTypeChange() {
      this.setParamsCookie();
    },
    setParamsCookie() {
      setCookie({
        key: "shippingOrderListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          receiptsTemplate: this.receiptsTemplate
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "shippingOrderListParams",
        type: "session"
      });
      if (prams) {
        let search = {};

        for (let key in prams) {
          if (
              key !== "pageSize" &&
              key !== "currentPage" &&
              key !== "receiptsTemplate"
          ) {
            search[key] = prams[key];
          }
        }
        // this.searchCondition = search;
        Object.assign(this.searchCondition, search);
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
        this.receiptsTemplate = prams.receiptsTemplate;
      }
    },
    async confirmEdit() {
      if (this.expressOrderSn === "") {
        this.$message({
          message: "请输入要修改的快递单号!",
          type: "warning"
        });
      } else {
        const { code } = await this.$store.dispatch("editExpressSn", {
          expressOrderSnOld: this.row.expressOrderSn,
          expressOrderSn: this.expressOrderSn.trim(),
          expressQueryId: this.row.expressQueryId
        });
        if (code === "0") {
          this.$message({
            message: "操作成功!",
            type: "success"
          });
          this.outerVisible = false;
          this.expressOrderSn = "";
          this.queryList();
        }
      }
    },
    editExpressOrderSn(row) {
      if (row.expressOrderSnOld === "") {
        this.row = row;
        this.outerVisible = true;
      }
    },
    async printNum() {
      const { code } = await this.$store.dispatch("addExpressPrintNum", {
        expressQueryId: this.printNumRow.expressQueryId
      });
      if (code === "0") {
        this.queryList();
      }
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    add() {
      this.list2.push([]);
      this.detailsOrderGoods.push([]);
    },
    start() {},
    end() {},
    move() {},
    cloneDog(prop) {
      let params = JSON.parse(JSON.stringify(prop));

      return params;
    },
    log(e) {
      if (e.added) {
        this.activePreviewIndex = e.added.newIndex;
        this.currentProp = {};
        this.currentProp = e.added.element.prop;
      } else if (e.moved) {
        this.activePreviewIndex = e.moved.newIndex;
      }
    },
    tableRowClassName({ row }) {
      if (row.returnType !== "no") {
        return "tuikuan";
      }
      return "";
    },
    particulars(row) {
      this.$store
          .dispatch("showExpressOrder", {
            orderId: row.orderId,
            expressQueryId: row.expressQueryId
          })
          .then(res => {
            this.detailsOrderGoods.push(res.result.orderGoods);
            this.dialogVisibleOrder = true;
          });
    },
    details(row) {
      this.dialogOrderDetails = true;
      this.$store.dispatch("detailOrder", {
        orderId: row.orderId,
        expressQueryId: row.expressQueryId
      });
    },
    confirmDelivery(row) {
      this.shippingType = "confirmDelivery";
      this.title = "确认发货";
      this.dialogVisibleOrder = true;
      this.row = row;
      this.particulars(row);
    },
    removeHang(row) {
      this.row = row;
      this.hangupMode = "this";
      this.editGuaQi();
    },
    tingZhi() {
      this.dialogVisibleShipping = false;
      this.searchCondition.timeStatus = "daifahuo";
      this.resetRuleForm();
      this.queryList();
    },
    submitExpress() {
      if (this.expressOrderSn) {
        this.orderRow.expressOrderSn = this.expressOrderSn.trim();
        this.continueType = "submitExpress";
        this.continueOrder = [this.orderRow];
        let params = [this.orderRow];
        this.$store.dispatch("batchOrderRecord", params).then(res => {
          if (res.code === "0") {
            params[0].still = false;
            this.$store
                .dispatch("expressPut", params)
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: "发货成功!",
                      type: "success"
                    });
                    this.isKuaiDiDan = false;
                    this.$nextTick(() => {
                      this.$refs.deliverSn.focus();
                    });
                    this.noNum = this.noNum - 1;
                    this.yesNum = this.yesNum + 1;
                    this.isDeliverSn = "";
                    this.expressOrderSn = "";
                    this.queryList();
                    this.shippedList.unshift(this.orderRow);
                    if (this.noNum === 0) {
                      this.dialogVisibleShipping = false;
                      this.searchCondition.timeStatus = "daifahuo";
                      this.queryList();
                    }
                  }
                })
                .catch(e => {
                  if (e.code === "-9999") {
                    this.errVisible = true;
                    this.errMsg = e.errMsg;
                  }

                  console.log("err: ", e);
                });
          }
        });
      } else {
        this.$message({
          message: "请填写快递单号！",
          type: "warning"
        });
      }
    },
    async queryKeywordOrderList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[0]
          : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[1]
          : "";
      // searchCondition.categoryId = this.isArray(searchCondition.categoryId)
      //   ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
      //   : searchCondition.categoryId;
      searchCondition.categoryId = "";  
      Object.assign(searchCondition, {
        keyword: this.isDeliverSn
      });
      const { result } = await this.$store.dispatch(
          "queryAllExpressOrderPage",
          searchCondition
      );
      const { order } = result;
      if (order.records.length) {
        let v = order.records[0];
        if (v.deliveryType === "kdfh" && !v.expressOrderSn) {
          this.orderRow = v;
          this.isKuaiDiDan = true;
          this.$nextTick(() => {
            this.$refs.express.focus();
          });
        } else {
          this.continueType = "queryKeywordOrderList";
          this.continueOrder = [v];
          let params = [v];
          params[0].still = false;
          this.$store
              .dispatch("expressPut", params)
              .then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: "发货成功!",
                    type: "success"
                  });
                  this.noNum = this.noNum - 1;
                  this.yesNum = this.yesNum + 1;
                  this.isDeliverSn = "";
                  this.queryList();
                  this.shippedList.unshift(v);
                  if (this.noNum === 0) {
                    this.dialogVisibleShipping = false;
                    this.searchCondition.timeStatus = "daifahuo";
                    this.queryList();
                  }
                }
              })
              .catch(e => {
                if (e.code === "-9999") {
                  this.errVisible = true;
                  this.errMsg = e.errMsg;
                }

                console.log("err: ", e);
              });
        }
      } else {
        this.$message({
          message: "发货失败,无匹配订单！",
          type: "warning"
        });
      }
    },
    submit() {
      console.log("this.isDeliverSn: ", this.isDeliverSn);
      this.queryKeywordOrderList();
      // if (this.isDeliverSn) {
      //   this.queryAllList().then(res => {
      //     let falg = false;

      //     res.map(v => {
      //       if (!this.isDeliverSn) {
      //         return;
      //       }
      //       if (
      //         v.deliverSn === this.isDeliverSn ||
      //         v.expressOrderSn === this.isDeliverSn ||
      //         v.billNo === this.isDeliverSn
      //       ) {
      //         falg = true;
      //         if (v.deliveryType === "kdfh" && !v.expressOrderSn) {
      //           this.orderRow = v;
      //           this.isKuaiDiDan = true;
      //           this.$nextTick(() => {
      //             this.$refs.express.focus();
      //           });
      //         } else {
      //           let params = [v];
      //           this.$store.dispatch("expressPut", params).then(res => {
      //             if (res.code === "0") {
      //               this.$message({
      //                 message: "发货成功!",
      //                 type: "success"
      //               });
      //               this.noNum = this.noNum - 1;
      //               this.yesNum = this.yesNum + 1;
      //               this.queryList();
      //               this.shippedList.unshift(v);
      //               if (this.noNum === 0) {
      //                 this.dialogVisibleShipping = false;
      //                 this.searchCondition.timeStatus = "daifahuo";
      //                 this.queryList();
      //               }
      //             }
      //           });
      //         }
      //       }
      //     });

      //     if (!falg) {
      //       this.$message({
      //         message: "发货失败,无匹配订单！",
      //         type: "warning"
      //       });
      //     }else{
      //               this.isDeliverSn = "";
      // }
      //   });
      // }
    },
    batchDelivery() {
      this.titleOrder = "批量发货";
      this.dialogVisibleShipping = true;
      this.shippedList = [];
      this.shippingType = "batchDelivery";
      this.$nextTick(() => {
        this.$refs.deliverSn.focus();
      });
      if (this.searchCondition.timeStatus === "daifahuo") {
        this.noNum = this.noExpress;
      } else {
        this.noNum = this.guaqiNum;
      }
    },
    printCourierReceipt(row) {
      let params = [row];
      this.$store.dispatch("orderPrint", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    async printInvoice(row) {
      this.printNumRow = row;
      const { code, result } = await this.$store.dispatch(
          "batchPrintOrderList",
          [row]
      );
      if (code === "0") {
        result.forEach(v => {
          v.orderGoodsNum = 0;
          v.orderGoods.forEach(j => {
            v.orderGoodsNum += new Number(j.goodsNum);
          });
        });
        this.dialogVisible = true;
        this.printNumType = "printNum";
        this.orderPrintList = result;
      }
    },
    async batchSetting() {
      if (this.checkedRow.length) {
        this.printNumType = "batch";
        const { code, result } = await this.$store.dispatch(
            "batchPrintOrderList",
            this.checkedRow
        );
        if (code === "0") {
          result.forEach(v => {
            v.orderGoodsNum = 0;
            v.orderGoods.forEach(j => {
              v.orderGoodsNum += new Number(j.goodsNum);
            });
          });

          this.orderPrintList = result;

          for (let i = 0; i < this.orderPrintList.length; i++) {
            await this.$store.dispatch("queryByIdShop", {shopId: this.checkedRow[i].shopId}).then(res=> {
              this.orderPrintList[i].shopPhone = res.result.shopPhone;
            });
          }
          this.dialogVisible = true;
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    async querySuppliers(storeCode) {
      const { result } = await this.$store.dispatch("querySupplier", {
        storeCode
      });
      this.querySupplier = result;
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    confirm() {
      if (this.shippingType === "assigned") {
        if (this.appointShopId !== "") {
          let params = {
            expressQueryId: this.row.expressQueryId,
            appointShopId: this.appointShopId
          };
          this.$store.dispatch("appointShop", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.dialogVisibleShipping = false;
              this.queryList();
              this.resetRuleForm();
            }
          });
        } else {
          this.$message({
            message: "请选择指派门店",
            type: "warning"
          });
        }
      }
    },
    submitForm() {
      if (this.searchCondition.expressSendMode === "third") {
        if (this.deliveryWay === "one") {
          if (this.isDeliverSn === "") {
            this.$message({
              message: "请选择填写快递单号",
              type: "warning"
            });
          } else {
            this.row.expressOrderSn = this.isDeliverSn;
            this.continueOrder = [this.row];
            this.continueType = "submitForm";
            let params = [this.row];
            params[0].still = false;
            this.$store
                .dispatch("expressPut", params)
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: "发货成功!",
                      type: "success"
                    });
                    this.dialogVisibleOrder = false;
                    this.resetRuleForm();
                    this.queryList();
                  }
                })
                .catch(e => {
                  if (e.code === "-9999") {
                    this.errVisible = true;
                    this.errMsg = e.errMsg;
                  }
                  console.log("err: ", e);
                });
          }
        } else {
          if (this.breakList.length > 0) {
            let orderPartJson = JSON.parse(JSON.stringify(this.breakList));
            orderPartJson.forEach(v => {
              v.orderDetailsJson.forEach(item => {
                item.goodsNum = item.shippingNum;
              });
            });
            let params = {
              expressQueryId: this.detailsExpressOrder.order.expressQueryId,
              orderPartJson
            };
            this.$store.dispatch("expressOrderPart", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisibleOrder = false;
                this.queryList();
                this.resetRuleForm();
              }
            });
          } else {
            this.$message({
              message: "请选择需要拆分的商品",
              type: "warning"
            });
          }
        }
        // if (this.isDeliverSn === "") {
        //   this.$message({
        //     message: "请选择填写快递单号",
        //     type: "warning"
        //   });
        // } else {
        //   this.row.expressOrderSn = this.isDeliverSn;
        //   let params = [this.row];
        //   this.$store.dispatch("expressPut", params).then(res => {
        //     if (res.code === "0") {
        //       this.$message({
        //         message: "发货成功!",
        //         type: "success"
        //       });
        //       this.dialogVisibleOrder = false;
        //       this.resetRuleForm();
        //       this.queryList();
        //     }
        //   });
        // }
      } else {
        if (this.breakList.length > 0) {
          let orderPartJson = JSON.parse(JSON.stringify(this.breakList));
          orderPartJson.forEach(v => {
            v.orderDetailsJson.forEach(item => {
              item.goodsNum = item.shippingNum;
            });
          });
          let params = {
            expressQueryId: this.detailsExpressOrder.order.expressQueryId,
            orderPartJson
          };
          this.$store.dispatch("expressOrderPart", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.dialogVisibleOrder = false;
              this.queryList();
              this.resetRuleForm();
            }
          });
        } else {
          this.$message({
            message: "请选择需要拆分的商品",
            type: "warning"
          });
        }
      }

      // if (this.shippingType === "single") {
      //   let orderPartJson = JSON.parse(JSON.stringify(this.breakList));
      //   orderPartJson.forEach(v => {
      //     v.orderDetailsJson.forEach(item => {
      //       item.goodsNum = item.shippingNum;
      //     });
      //   });
      //   let params = {
      //     expressQueryId: this.detailsExpressOrder.order.expressQueryId,
      //     orderPartJson
      //   };
      //   this.$store.dispatch("expressOrderPart", params).then(res => {
      //     if (res.code === "0") {
      //       this.$message({
      //         message: "操作成功",
      //         type: "success"
      //       });
      //       this.dialogVisibleOrder = false;
      //       this.queryList();
      //       this.resetRuleForm();
      //     }
      //   });
      // } else {
      //   let orderPartJson = JSON.parse(JSON.stringify(this.breakList));
      //   orderPartJson.forEach(v => {
      //     v.orderDetailsJson.forEach(item => {
      //       item.goodsNum = item.shippingNum;
      //     });
      //   });
      //   let params = {
      //     expressQueryId: this.detailsExpressOrder.order.expressQueryId,
      //     orderPartJson
      //   };
      // }
    },
    remove(index, row) {
      this.breakList.splice(index, 1);
      row.orderDetailsJson.forEach(item => {
        this.detailsExpressOrder.orderGoods.forEach(v => {
          if (item.skuId === v.skuId) {
            v.goodsNum = v.goodsNum + item.shippingNum;
          }
        });
      });
    },
    breakUp() {
      let show = false;
      let singleFlag = false;
      let breakList = [];
      let tempList = this.detailsExpressOrder.orderGoods;
      this.detailsExpressOrder.orderGoods.forEach(function(v, i) {
        console.log("goodsNum:" + v.goodsNum, "shippingNum:" + v.shippingNum);
        if (v.shippingNum && v.shippingNum !== "") {
          show = true;
          if (v.goodsNum - v.shippingNum > 0) {
            breakList.push(v);
          } else if (v.goodsNum - v.shippingNum == 0) {
            breakList.push(v);
            tempList.splice(i,1);
          } else {
            singleFlag = true;
          }
        }
      });
      this.detailsExpressOrder.orderGoods = tempList;

      if (show) {
        console.log("show:" + show + ",singleFlag:" + singleFlag + ",this.shippingType:" + this.shippingType + ",this.appointShopId:" + this.appointShopId);
        if (singleFlag) {
          this.$message({
            message: "拆单发货数量不能大于订单数量",
            type: "warning"
          });
        } else {
          if (this.shippingType === "single") {
            if (this.appointShopId !== "") {
              let goodsNameLists = [];

              breakList.forEach(v => {
                v.shippingNum = Number(v.shippingNum);
                v.goodsNum = v.goodsNum - v.shippingNum;
                // goodsNames += v.spuName + "×" + v.shippingNum + ",;
                goodsNameLists.push(v.spuName + "×" + v.shippingNum);
              });
              // goodsNameList = goodsNameLists.join("<br/>");
              let breakLists = JSON.parse(JSON.stringify(breakList));
              let appointShopName = "";
              if (this.storeCode === '53010017032439' || this.storeCode === '42010216070190') {
                this.dkShops.filter(v=>{
                  if (v.shopId == this.appointShopId) {
                    appointShopName = v.shopName;
                  }
                })
              } else {
                this.expressShopList.filter(v=>{
                  if (v.shopId == this.appointShopId) {
                    appointShopName = v.shopName;
                  }
                })
              }
              let params = {
                goodsNames: goodsNameLists.join(","),
                goodsNameList: goodsNameLists.join("<br/>"),
                orderDetailsJson: breakLists,
                appointShopId: this.appointShopId,
                appointShopName: appointShopName,
                receiptSn: this.detailsExpressOrder.order.receiptSn,
                expressSendMode: this.detailsExpressOrder.order.expressSendMode
              };
              this.breakList.push(params);
              //拆分完之后拆分的条目检查是否有数量为0的商品
              // let tempList = this.detailsExpressOrder.orderGoods;
              // this.detailsExpressOrder.orderGoods.forEach(function(v,i) {
              //   if (v.goodsNum - v.shippingNum <= 0) {
              //     console.log("删除。。。v.goodsNum:" + v.goodsNum + ",v.shippingNum:" + v.shippingNum )
              //     tempList.splice(i,1);
              //   }
              // })
              // this.detailsExpressOrder.orderGoods = tempList;
            } else {
              this.$message({
                message: "请选择指派门店",
                type: "warning"
              });
            }
          } else if (this.shippingType === "confirmDelivery") {
            if (this.isDeliverSn !== "") {
              let goodsNameLists = [];

              breakList.forEach(v => {
                v.shippingNum = Number(v.shippingNum);
                v.goodsNum = v.goodsNum - v.shippingNum;
                // goodsNames += v.spuName + "×" + v.shippingNum + ",;
                goodsNameLists.push(v.spuName + "×" + v.shippingNum);
              });
              // goodsNameList = goodsNameLists.join("<br/>");
              let breakLists = JSON.parse(JSON.stringify(breakList));
              let params = {
                goodsNames: goodsNameLists.join(","),
                goodsNameList: goodsNameLists.join("<br/>"),
                orderDetailsJson: breakLists,
                expressOrderSn: this.isDeliverSn,
                appointShopName: this.detailsExpressOrder.order.shopName,
                receiptSn: this.detailsExpressOrder.order.receiptSn,
                expressSendMode: this.detailsExpressOrder.order.expressSendMode
              };
              this.breakList.push(params);
            } else {
              this.$message({
                message: "请填写快递单号",
                type: "warning"
              });
            }
          }
        }
      } else {
        this.$message({
          message: "请填写发货数量",
          type: "warning"
        });
      }
    },
    // selectGetFn(val) {
    //   // let selectedWorkName = {};
    //   let selectedWorkName = this.expressShopList.find(item => {
    //     return item.shopId === val;
    //   });
    // },
    async queryAllShopList() {
      const { result } = await this.$store.dispatch("expressShopList");
      this.expressShopList = result;
    },
    filterGt0(index, prop) {
      this.detailsExpressOrder.orderGoods[index][
          prop
          ] = this.detailsExpressOrder.orderGoods[index][prop].replace(/^(0+)/, ""); //过滤0开头
      this.detailsExpressOrder.orderGoods[index][
          prop
          ] = this.detailsExpressOrder.orderGoods[index][prop].replace(
          /^(0+)|[^\d]+/g,
          ""
      );
      this.detailsExpressOrder.orderGoods[index][
          prop
          ] = this.detailsExpressOrder.orderGoods[index][prop].replace(
          /\.{2,}/g,
          ""
      ); //两个连续的"."仅保留第一个"."
    },
    single(row) {
      // this.detailsOrderGoods = [];
      // this.dialogTest = true;
      this.shippingType = "single";
      this.title = "分单发货";
      this.particulars(row);
    },
    assigned(row) {
      this.titleOrder = "指派门店";
      this.dialogVisibleShipping = true;
      this.shippingType = "assigned";
      this.row = row;
      this.appointShopId = row.shopId;
    },
    allHang() {
      this.hangupMode = "all";
      this.editGuaQi();
    },
    oneselfHang() {
      this.hangupMode = "this";
      this.editGuaQi();
    },
    hang(row) {
      this.titleOrder = "挂起";
      this.shippingType = "hang";
      this.row = row;
      this.guaQiVerify();
    },
    async guaQiVerify() {
      let params = {
        receiptSn: this.row.receiptSn,
        hangupState: this.row.hangupState
      };
      const { code, result } = await this.$store.dispatch(
          "expressOrderGuaqiverify",
          params
      );
      if (code === "0") {
        if (result) {
          this.editGuaQi();
        } else {
          this.dialogVisibleShipping = true;
        }
      }
    },
    async querySupplierInfoComboBox() {
      const { result } = await this.$store.dispatch(
          "querySupplierInfoComboBox"
      );
      this.supplierInfoList = result;
    },
    async editGuaQi() {
      let params = {
        expressQueryId: this.row.expressQueryId,
        hangupState: this.row.hangupState,
        receiptSn: this.row.receiptSn,
        hangupMode: this.hangupMode
      };
      const { code } = await this.$store.dispatch(
          "editExpressOrderGuaqi",
          params
      );
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.dialogVisibleShipping = false;
        this.queryList();
        this.resetRuleForm();
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    switchTab(val) {
      this.searchCondition.supplierId = "";
      this.searchCondition.querySnValue = "";
      if (val === "self") {
        this.searchCondition.timeStatus = "daipeihuo";
      } else {
        this.searchCondition.timeStatus = "daifahuo";
      }
      this.currentPage = 1;
      this.queryList();
    },
    shippingSwitchTab() {
      this.currentPage = 1;
      this.checkedRow = [];
      this.queryList();
      this.$nextTick(() => {
        this.$refs.table.doLayout(); //解决表格错位
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    toBreak(val) {
      return val.split(",").join("<br/>");
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      let queryStartTime = this.isArray(this.searchCondition.applyDate)
          ? this.searchCondition.applyDate[0]
          : "";
      let categoryId = this.isArray(this.searchCondition.categoryId)
        ? this.searchCondition.categoryId[this.searchCondition.categoryId.length - 1]
        : "";
      if( !queryStartTime ){
        this.$message({
          message: "请选择查询时间",
          type: "warning"
        });
        return;
      }
      // if (this.isArray(this.searchCondition.applyDate)) {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[0]
          : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[1]
          : "";
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;
      Object.assign(params, searchCondition);
      this.setParamsCookie();
      // 并行调用获取订单列表和统计数据
      const [orderResult, statResult] = await Promise.all([
        this.$store.dispatch("queryExpressOrderPage", params),
        this.$store.dispatch("queryExpressOrderStat", params)
      ]);
      
      // 处理订单列表数据
      const { order } = orderResult.result;
      this.list = order.records;
      
      // 处理统计数据
      const { number } = statResult.result;
      this.noDelivery = number.waitAllocationNum;
      this.noExpress = number.waitDeliverNum;
      this.isExpress = number.alreadyDeliverNum;
      this.guaqiNum = number.guaqiNum;
      this.list.forEach(v => {
        if (v.goodsNames.indexOf(",")) {
          v.tooltipGoodsName = this.toBreak(v.goodsNames);
        } else {
          v.tooltipGoodsName = [v.goodsNames];
        }
      });
      this.total = order.total;

      if (this.total) {
        this.querySuppliers(this.list[0].storeCode);
      }

      return this.list;
      // } else {
      //   this.$message({
      //     message: "请选择下单时间段！",
      //     type: "warning"
      //   });
      // }
    },
    async queryAllList() {
      // if (this.isArray(this.searchCondition.applyDate)) {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[0]
          : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[1]
          : "";
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;    
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryAllExpressOrderPage",
          params
      );
      const { order } = result;
      return order.records;
      // } else {
      //   this.$message({
      //     message: "请选择下单时间段！",
      //     type: "warning"
      //   });
      // }
    },

    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
            .then(res => {
              const list = res;
              list.forEach(v => {
                if (v.deliveryType === "mdzt") {
                  v.deliveryType = "门店自提";
                } else if (v.deliveryType === "kdfh") {
                  v.deliveryType = "快递发货";
                } else if (v.deliveryType === "tcps") {
                  v.deliveryType = "同城配送";
                }
              });
              const tHeader = this.$refs.table.columns
                  .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
                  .filter(o => o);
              let filterVal = [];
              if (list.length > 0) {
                filterVal = this.$refs.table.$children
                    .map(o => o._props.prop)
                    .filter(o => o);
              }
              const data = this.formatJson(filterVal, list);
              exportJsonToExcel(
                  tHeader,
                  data,
                  title + new Date().toLocaleString()
              );
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    async queryAllThirdList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryThirdExpressOrderDetailsList",
          searchCondition
      );
      // const { order } = result;
      return result;
    },
    // 导出第三方excel
    outputThird(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
            .then(res => {
              const list = res;
              // const tHeader = this.$refs.table.columns
              //   .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              //   .filter(o => o);
              const tHeader = [
                "发货单号（不允许修改）",
                "订单号（不允许修改）",
                "订单商品ID（不允许修改）",
                "商品名称（不允许修改）",
                "商品数量",
                "供应商ID（不允许修改）",
                "供应商名称（不允许修改）",
                "门店ID（不允许修改）",
                "门店名称（不允许修改）",
                "快递单号"
              ];
              const filterVal = [
                "deliverSn",
                "receiptSn",
                "orderDetailsId",
                "goodsName",
                "goodsNum",
                "supplierId",
                "supplierName",
                "appointShopId",
                "shopName",
                "expressOrderSn"
              ];
              // let filterVal = [];
              // if (list.length > 0) {
              //   filterVal = this.$refs.table.$children
              //     .map(o => o._props.prop)
              //     .filter(o => o);
              // }
              const data = this.formatJson(filterVal, list);
              exportJsonToExcel(
                  tHeader,
                  data,
                  title + new Date().toLocaleString()
              );
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isRequired = true;
        result.forEach(v => {
          if (
              !v[0] ||
              !v[1] ||
              !v[2] ||
              !v[3] ||
              !v[4] ||
              !v[5] ||
              !v[6] ||
              !v[7] ||
              !v[8] ||
              !v[9]
          ) {
            isRequired = false;
          } else {
            formatResult.push({
              deliverSn: v[0],
              receiptSn: v[1],
              orderDetailsId: v[2],
              goodsName: v[3],
              goodsNum: v[4],
              supplierId: v[5],
              supplierName: v[6],
              appointShopId: v[7],
              shopName: v[8],
              expressOrderSn: v[9]
            });
          }
        });
        if (isRequired) {
          let params = {
            thirdExcelJson: formatResult
          };
          that.$store
              .dispatch("excelExpressOrderDetailsPart", params)
              .then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: " 操作成功",
                    type: "success"
                  });
                  this.queryList();
                }
              });
          // that.rightData = formatResult;
          // that.memberCount = formatResult.length;
        } else {
          that.$message({
            message: "导入失败，请导入完整发货信息！",
            type: "warning"
          });
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    // isArray(arr) {
    //   return Object.prototype.toString.call(arr) === "[object Array]";
    // },
    printTe() {
      console.log("this.checkedRow.length: ", this.checkedRow.length);
      document.getElementById("btn").blur();
      this.$print(this.$refs[this.receiptsTemplate]);
      if (this.checkedRow.length && this.printNumType != "printNum") {
        this.$store.dispatch("batchOrderRecord", this.checkedRow).then(res => {
          if (res.code === "0") {
            this.queryList();
            this.dialogVisible = false;
            this.$store.dispatch("orderPrint", this.checkedRow).then(res => {
              if (res.code === "0") {
                // this.$message({
                //   message: " 操作成功",
                //   type: "success"
                // });
                this.queryList();
              }
            });
          }
        });
      }

      if (this.printNumType === "printNum") {
        this.printNum();
      }
    },
    cancel() {
      this.dialogVisibleShipping = false;
      this.dialogDetails = false;
      this.dialogVisible = false;
      this.dialogVisibleOrder = false;
      this.dialogOrderDetails = false;
      this.resetRuleForm();
    },
    resetRuleForm() {
      setTimeout(() => {
        this.hangupMode = "this";
        this.row = {};
        this.appointShopId = "";
        this.breakList = [];
        this.noNum = 0;
        this.yesNum = 0;
        this.isDeliverSn = "";
        this.deliveryWay = "one";
      }, 0);
    },
    async reAddOrder(row) {
      const { code, result } = await this.$store.dispatch(
          "reAddOrder",
          {
            receiptSn: row.receiptSn
          }
      );

    }
  }
};
</script>
<style lang="scss">
.page-x__scroll .el-scrollbar__wrap {
  overflow-y: hidden;
}
</style>
<style lang="scss" scoped>
.empty {
  width: 100%;
  box-sizing: border-box;
  padding-top: 40px;
  .empty_tex {
    font-size: 18px;
    color: #666666;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    padding: 0;
  }
}
.label-third {
  width: 120px;
  text-align: right;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  font-weight: 700;
}
.suc {
  font-size: 17px;
  font-weight: bold;
}
.yuan {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #2fc348;
  .icon-duigou {
    line-height: 100px;
    text-align: center;
    color: #fff;
  }
}
.errtip {
  font-size: 14px;
  color: #222222;
  font-weight: bold;
}
.only-tuikuan {
  opacity: 0.3;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.warning-tuikuan {
  position: absolute;
  left: 0;
  top: 0;
}
.left-triangle {
  width: 0;
  height: 0;
  border-bottom: 50px solid #e50065;
  border-right: 30px solid transparent;
}
.right-triangle {
  width: 0;
  height: 0;
  border-bottom: 50px solid #e50065;
  border-left: 30px solid transparent;
}
.bgc {
  background-color: #e50065;
}
.list-group {
  width: 200px;
  padding: 10px;
  // border: 1px solid #000;
  .list-group-item {
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
    &:hover {
      transition: all 0.2s linear;
      background-color: #fddfeb !important;
      border-radius: 2px;
      color: rgb(226, 0, 93);
      .label {
        color: rgb(226, 0, 93);
      }
    }
  }
  .preview-list-group-item {
    padding: 10px;
    &.active,
    &.active:hover {
      box-sizing: border-box;
      border: 2px solid #ea5798;
      cursor: move;
    }
    &:hover {
      box-sizing: border-box;
      border: 2px dashed #ea5798;
      cursor: move;
    }
    transition: all 0.2s linear;
    background-color: #fddfeb !important;
    border-radius: 2px;
    color: #e2005d;
    text-align: center;
  }
}
.delete {
  cursor: pointer;
  user-select: none;
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tuikuan {
  background: rgba(255, 240, 240, 1);
  // border: 1px solid rgba(255, 0, 0, 1);
  position: relative;
  z-index: 9999999;
}
.oneLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-lists,
.info-list {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.info-lists {
  // padding: 0 20px;
  .content {
    margin: -10px -20px -20px -20px;
  }
  .fz {
    font-size: 12px;
  }
  .mb5 {
    margin-bottom: 5px;
  }
  .tit {
    padding: 20px;
    border-bottom: 5px solid #000000;
  }
  .hr {
    width: 1px;
    height: 92px;
    background-color: #b7b7b7;
  }
  .logoImg {
    width: 92px;
    height: 92px;
    padding-right: 20px;

    img {
      width: 100px;
      height: 100px;
    }
  }
  .sh-info {
    padding-left: 10px;
    width: 230px;
    border-left: 2px solid #b7b7b7;
    .sh-name {
      font-size: 20px;
      font-weight: 600;
    }
    .sh-xinxi {
      line-height: 24px;
    }
  }
  .consignee {
    border-bottom: 2px solid #b7b7b7;
    padding: 20px 0;
    div {
      line-height: 24px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    font-weight: 700;
    font-size: 12px;
    > div {
      padding: 10px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 10px;
    }
  }
}
</style>
